<div class="container-fluid">
  <page-header-breadcrumb
  [pageTitleValue]="pageTitle"
  [pageLinkValue]="'/centers'"
  [currentPageValue]="editMode ? 'Edit Lab' : 'Add Lab'"
></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="card-body">
      <form [formGroup]="addLabForm" (ngSubmit)="onAddLabSubmit()">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="lab-name">
                Lab Name
              </label>
              <input
                class="form-control"
                id="lab-name"
                formControlName="enLabName"
                placeholder="Lab Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addLabForm.controls.enLabName.dirty) &&
                  addLabForm.controls.enLabName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addLabForm.controls.enLabName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addLabForm.controls.enLabName.errors.pattern">
                  This field accept only English characters!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="lab-ar-name">
                Lab Arabic Name
              </label>
              <input
                class="form-control"
                id="lab-ar-name"
                formControlName="arLabName"
                placeholder="Lab Arabic Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addLabForm.controls.arLabName.dirty) &&
                  addLabForm.controls.arLabName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addLabForm.controls.arLabName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addLabForm.controls.arLabName.errors.pattern">
                  This field accept only arabic characters!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="lab-phone">
                Phone Number
              </label>
              <input
                class="form-control"
                id="lab-phone"
                formControlName="labPhone"
                placeholder=" Phone Number"
                type="number"
              />
              <div
                *ngIf="isSubmited && addLabForm.controls.labPhone.errors"
                class="input-errors"
              >
                <p *ngIf="addLabForm.controls.labPhone.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="lab-email">
                Email
              </label>
              <input
                class="form-control"
                id="lab-email"
                formControlName="labEmail"
                placeholder=" Email"
                type="email"
              />
              <div
                *ngIf="isSubmited && addLabForm.controls.labEmail.errors"
                class="input-errors"
              >
                <p *ngIf="addLabForm.controls.labEmail.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="lab-type">
                Lab Type
              </label>
              <select
                formControlName="labType"
                class="form-control"
                id="lab-type"
              >
                <option
                  *ngFor="let item of labTypes; let i = index"
                  [value]="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
              <div
                *ngIf="isSubmited && addLabForm.controls.labType.errors"
                class="input-errors"
              >
                <p *ngIf="addLabForm.controls.labType.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="lab-country">
                Countries
              </label>
              <select
                formControlName="labCountry"
                class="form-control"
                id="lab-country"
              >
                <option
                  *ngFor="let country of countries; let i = index"
                  [value]="country.id"
                >
                  {{ country.name }}
                </option>
              </select>
              <div
                *ngIf="isSubmited && addLabForm.controls.labCountry.errors"
                class="input-errors"
              >
                <p *ngIf="addLabForm.controls.labCountry.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <div class="custom-file">
                <input
                  (change)="onImageUpload($event)"
                  class="custom-file-input d-none"
                  id="lab-logo"
                  lang="en"
                  type="file" accept=".jpg,.png"
                />
                <label class="icon-image-placeholder placeholder" id="placeholder" for="lab-logo">
                </label>
                <input type="hidden" name="fileHidden" formControlName="labFileInput" />
                <div
                  *ngIf="isSubmited && addLabForm.controls.labFileInput.errors"
                  class="input-errors"
                >
                  <p *ngIf="addLabForm.controls.labFileInput.errors.required">
                    This field is required!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <label class="mr-6 mb-0" for="active-check">is Active</label>
            <label class="custom-toggle custom-toggle-default">
              <input
                checked="checked"
                type="checkbox"
                id="active-check"
                formControlName="labActiveCheck"
              />
              <span
                class="custom-toggle-slider rounded-circle"
                data-label-off="No"
                data-label-on="Yes"
              >
              </span>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col btns-block">
            <button class="btn btn-primary" type="submit" [disabled]="addLabForm.invalid">
              {{ editMode ? "Edit" : "Save" }}
            </button>
            <button
              class="btn btn-outline-danger"
              type="button"
              [routerLink]="'/centers'"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
